import * as apiCommon from '../apiCommon';
import { ITEM_LOCATION } from '../../constants/constant_doc_types';

export async function getItemLocations(app, params) {
  const { locationId, itemIds } = params;

  return apiCommon
    .queryDocs(
      app,
      ITEM_LOCATION,
      {
        limit: itemIds.length,
        location: locationId,
        items: itemIds,
        // fields: [
        //   'id',
        //   'item_id',
        //   'location_id',
        //   'on_hand',
        //   'back_order_quantity',
        //   'in_transit',
        //   'item_type',
        //   'average_cost',
        //   'subsidiary_id',
        //   'location_type',
        // ],
      },
      'post',
    )
    .then((result) => result.data);
}
